/** 订单状态（与后端 myOrders status 一致） */
export const ORDER_STATUS = {
  PENDING: 'PENDING',
  NEW: 'NEW',
  PARTIALLY_FILLED: 'PARTIALLY_FILLED',
  FILLED: 'FILLED',
  CANCELLED: 'CANCELLED',
  REJECTED: 'REJECTED',
  EXPIRED: 'EXPIRED',
};

/** 各 Tab 对应的 statusList（唯一来源，禁止在组件内散落字符串） */
export const TAB_STATUS_LIST = {
  open: [ORDER_STATUS.PENDING, ORDER_STATUS.NEW, ORDER_STATUS.PARTIALLY_FILLED],
  history: [ORDER_STATUS.FILLED, ORDER_STATUS.PARTIALLY_FILLED, ORDER_STATUS.CANCELLED],
  failed: [ORDER_STATUS.REJECTED],
};

export const ACTIVITY_TAB = {
  ORDER_BOOK: 'orderBook',
  HOLDINGS: 'holdings',
  OPEN: 'open',
  HISTORY: 'history',
  FAILED: 'failed',
};
